import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import constants from 'helpers/constants';
import {MaterialDesignContent} from 'notistack';
import utils from 'helpers/utils';

const StyledSnackbar = styled(MaterialDesignContent)
  .attrs((props) => {
    let attr = props;

    const baseColorVars = props.theme.color2Css('Snackbar', null, props.color, {
      varPrefix: 'snackbar',
      variables: true,
      type: constants.colorTypes.paper
    });

    attr = utils.styleProps(attr, baseColorVars.vars, {baseColor: baseColorVars.css});

    const vars = {
      '--snackbar-button-color': props.theme.property(`palette.${props.color}.contrastText`)
    };

    return utils.styleProps(attr, vars);
  })`
  ${props => props.$css.baseColor}
  
  &.Snackbar-size-small {
    max-width: ${props => props.theme.layout(200)};
  }
  &.Snackbar-size-medium {
    max-width: ${props => props.theme.layout(400)};
  }
  &.Snackbar-size-large {
    max-width: ${props => props.theme.layout(600)};
  }
  
  .Button-text {
    color: ${props => props.$css.$var('--snackbar-button-color', false)} !important;
  }
  
  ${ComponentStyles}
`;

StyledSnackbar.propTypes = {
};

export default StyledSnackbar;
